enum InvoiceType {
	Temp = 1,
    Perm = 2
}

export default InvoiceType;